import React from "react";

import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, MenuProps } from "@mui/material";
// import VerticalSplitOutlinedIcon from "@mui/icons-material/VerticalSplitOutlined";

import { DocumentSectionType } from "constants/documents";

interface Props extends Omit<MenuProps, "onSelect"> {
  onSelect: (data: { type: DocumentSectionType; isAiMeeting?: boolean }) => void;
  documentDealId: number | null;
}
export const AddSectionContextMenu: React.FC<Props> = (props) => {
  const { onSelect, documentDealId, ...menuProps } = props;
  return (
    <Menu {...menuProps} slotProps={{ paper: { sx: { borderRadius: "8px" } } }}>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Text })}>
        <ListItemIcon>
          <ArticleOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Text</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Image })}>
        <ListItemIcon>
          <ImageOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Image</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Question })}>
        <ListItemIcon>
          <HelpOutlineOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Question</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.AIQuestion })}>
        <ListItemIcon>
          <AttachFileOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>File</ListItemText>
      </MenuItem>
      <Divider sx={{ borderColor: "#DBE8F5", margin: "0px 15px" }} />
      <Box sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: "600", color: "#496682", p: "4px 16px" }}>
        REPORT
      </Box>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.KPI })}>
        <ListItemIcon>
          <SpeedOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>KPI</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Graph })}>
        <ListItemIcon>
          <InsertChartOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Graph</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Table })}>
        <ListItemIcon>
          <TableChartOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Table</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.CashflowGraph })}>
        <ListItemIcon>
          <AccountBalanceOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Cashflow</ListItemText>
      </MenuItem>
      {documentDealId && (
        <MenuItem onClick={() => onSelect({ type: DocumentSectionType.AnalyzeFundTable })}>
          <ListItemIcon>
            <PictureAsPdfOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
          </ListItemIcon>
          <ListItemText>Analyze Fund PDF </ListItemText>
        </MenuItem>
      )}
       <Divider sx={{ borderColor: "#DBE8F5", margin: "0px 15px" }} />
      <Box sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: "600", color: "#496682", p: "4px 16px" }}>
        MEETINGS
      </Box>

      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Meeting, isAiMeeting: true })}>
        <ListItemIcon>
          <RecordVoiceOverOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Transcripted Meeting</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onSelect({ type: DocumentSectionType.Meeting, isAiMeeting: false })}>
        <ListItemIcon>
          <EventOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>New Meeting</ListItemText>
      </MenuItem>

      {/* <MenuItem onClick={() => onSelect(DocumentSectionType.RichText)}>
        <ListItemIcon>
          <VerticalSplitOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />
        </ListItemIcon>
        <ListItemText>Rich text</ListItemText>
      </MenuItem> */}
    </Menu>
  );
};
